module.exports = __webpack_public_path__ + "static/media/16UNODC35.e439a081.jpg";